import React from 'react';

export const WixStyleReactContext = React.createContext({
  newColorsBranding: false,
  newBrandingClass: 'no-brand',
});
